import React from 'react';
import PropTypes from 'prop-types';

const ZoomIn = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="6.5"
      stroke={color}
      strokeWidth="1.8"
    />
    <path
      d="M7 10H13M10 7V13"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.8 14.8L20 20"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

ZoomIn.propTypes = {
  color: PropTypes.string,
};

export default ZoomIn;
